import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import SEO from '../components/SEO';
import { PageHero } from '../components/marketing';

const FAQS = [
  { q: 'How much do your services cost?', a: 'A free 30-minute consultation, then transparent flat fees. Most students invest $500–$2,500 across the journey, and our average aid recovery is $9,400 — so the service usually pays for itself many times over.' },
  { q: 'Which countries do you support?', a: 'Canada, USA, UK, Australia, Ireland, Germany and several Asian study destinations. Canada is where we have the deepest network, with 50+ direct partner colleges.' },
  { q: 'I have already applied. Can you still help?', a: 'Yes. We can support mid-application reviews, escalate stalled files, and prep you for interviews and visas regardless of where in the process you are.' },
  { q: 'Do you guarantee admission?', a: 'No reputable counsellor can. What we guarantee is a strong, complete application package and full transparency on your acceptance odds at every shortlisted program.' },
  { q: 'How are you different from a typical agent?', a: 'Most agents are paid by colleges, so they push wherever the commission is highest. We charge students directly so our advice is genuinely on your side. We also publish all our partner colleges publicly.' },
  { q: 'Do you help with visas?', a: 'Yes — our team includes RCIC-licensed practitioners for Canada and partners for other regions. Visa support is included in our full-package service.' },
];

export default function FAQPage() {
  const [open, setOpen] = useState(0);
  return (
    <div className="bg-tge-paper min-h-screen">
      <SEO title="FAQ — True Global Education" />
      <PageHero
        eyebrow="Frequently asked"
        title="Straight answers to the questions everyone has."
        intro="Cannot find what you are looking for? Email us at info@trueglobaleducation.com — we reply within one business day."
      />
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-6 py-20">
          <div className="space-y-3">
            {FAQS.map((it, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="bg-tge-cream-soft rounded-2xl overflow-hidden">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left"
                  >
                    <span className="font-serif-display text-lg sm:text-xl text-tge-navy pr-4">{it.q}</span>
                    <span className="w-9 h-9 rounded-full bg-tge-navy text-white flex items-center justify-center flex-shrink-0">
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 0.9, 0.32, 1] }}
                        className="overflow-hidden"
                      >
                        <div className="px-6 pb-6 text-tge-muted leading-relaxed">{it.a}</div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
